import {web_search_engine_filter} from './web_search_engine_filter';
import {web_search_engine_cache} from './web_search_engine_cache';
export class web_search_engine {
    public id:number;
    public name:string;
    public web_search_engine_filters:web_search_engine_filter[]=[];
    public web_search_engine_caches:web_search_engine_cache[]=[];
}